module.exports = __webpack_public_path__ + "static/media/directadmin.bb665cf9.svg";